import { useEffect, useState } from "react";
import { SignInHeader } from "../components/Auth/SignInHeader/SignInHeader";
import { SignInFooter } from "../components/Auth/SignInFooter/SignInFooter";
import * as Sentry from "@sentry/browser";

import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { authenticatorServices } from "../utils/authenticatorServices";
import { useNavigate } from "react-router";
import { BusinessAdmin } from "../types/schema";
import { authClient } from '../utils/amplifyClient';
import { updateBusinessAdmin as updateBusinessAdminMutation } from "../graphql/mutations";
import { AuthUser, fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import { useParams } from "react-router-dom";
import { getBusinessAdmin as getBusinessAdminQuery } from "../graphql/queries";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { NotFound } from "./NotFound";

import "../css/RegistrationPages.css"
import { SignUpHeaderBusinessAdminRegistration } from "../components/Auth/SignUpHeader/SignUpHeader";
import TotalEquipIQLogoStacked from "../components/ui/icons-logos/TotalEquipIQLogoStacked";

export const BusinessAdminRegister = () => {
    const { user, route } = useAuthenticator((context) => [
        context.route,
    ]);
    const { userIdFromParams } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [businessAdminNotFound, setBusinessAdminNotFound] = useState(false);
    const [businessAdminFromId, setBusinessAdminFromId] = useState<BusinessAdmin | null>(null);
    useNavigate();
    const { toForgotPassword } = useAuthenticator();

    useEffect(() => {
        const getUserFromId = async () => {
            try {
                const result = await authClient.graphql({
                    query: getBusinessAdminQuery,
                    variables: { id: userIdFromParams as string },
                    authMode: "apiKey",
                });
                setIsLoading(false);
                if (!result.data.getBusinessAdmin) {
                    return setBusinessAdminNotFound(true);
                }
                setBusinessAdminFromId(result.data.getBusinessAdmin as BusinessAdmin);
            } catch (error) {
                console.log("error", error);
                Sentry.captureException(error);
            }
        };
        if (!businessAdminFromId && userIdFromParams) {
            getUserFromId();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        const updateBusinessAdminWithCognitoId = async (currentUser: AuthUser) => {
            try {
                const attributes = await fetchUserAttributes();

                // Re-fetch to get latest state
                const result = await authClient.graphql({
                    query: getBusinessAdminQuery,
                    variables: { id: userIdFromParams as string },
                    authMode: "apiKey",
                });
                const freshAdmin = result.data.getBusinessAdmin;

                if (!freshAdmin) {
                    return setBusinessAdminNotFound(true);
                }

                // Case 1: No cognitoId or pending — link this account
                if (!freshAdmin.cognitoId || freshAdmin.cognitoId.startsWith("pending-")) {
                    const input = {
                        id: userIdFromParams as string,
                        cognitoId: currentUser.userId,
                        name: attributes.name || freshAdmin.name,
                    };
                    await authClient.graphql({
                        query: updateBusinessAdminMutation,
                        variables: { input },
                        authMode: "userPool",
                    });
                    window.location.href = "/";
                    return;
                }

                // Case 2: Already linked to this user — just redirect
                if (freshAdmin.cognitoId === currentUser.userId) {
                    window.location.href = "/";
                    return;
                }

                // Case 3: Linked to someone else
                setBusinessAdminNotFound(true);
            } catch (error) {
                console.log("error fetching user attributes", error);
                Sentry.captureException(error);
            }
        };
        const getNewUser = async () => {
            const newUser = await getCurrentUser();
            updateBusinessAdminWithCognitoId(newUser);
        };
        if (route === "authenticated") {
            getNewUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [route, businessAdminFromId, user]);



    const components = {
        SignIn: {
            Header() {
                return <SignInHeader />;
            },
            Footer() {
                return (
                    <SignInFooter
                        toForgotPassword={toForgotPassword}
                        forgotPasswordText="Forgot Password"
                    />
                );
            },
        },
        SignUp: {
            Header() {
                return <SignUpHeaderBusinessAdminRegistration />;
            },
        },
    };
    const formFields = {
        signUp: {
            name: {
                placeholder: "Enter Your Name Here",
                isRequired: true,
                label: "Name:",
            },
        },
    }
        ;
    return (
        <LoadingSpinner
            content={businessAdminNotFound ? (<NotFound />) : (
                <>
                    <div className="fixed-logo">
                        <TotalEquipIQLogoStacked iconClasses="fixed-logo-mark" ariaLabel="TotalEquipIQ" />
                    </div>
                    <div className="auth-wrapper-register">
                        <div className=" centered-wrapper-register">
                            <Authenticator
                                services={authenticatorServices}
                                initialState={businessAdminFromId?.cognitoId && !businessAdminFromId.cognitoId.startsWith("pending-") ? "signIn" : "signUp"}
                                formFields={formFields}
                                components={components}
                                loginMechanisms={["email"]}
                            ></Authenticator>
                        </div>
                    </div>
                </>

            )} isLoading={isLoading} />
    );
};